export class AddUserClientRequest {
    userId: number;
    applicationId: number;
    clientId: number;
    adminRole: boolean;
    reportingRole: boolean;
    viewReferrals: boolean;
    custodianRole: boolean;

    constructor() {}
}